import { TIER_DISPLAY_NAMES } from '@/atoms/subscription.atom';
import { Button } from '@/components/ui/button';
import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useOrganizations } from '@/hooks/useOrganizations';
import { FEATURE_GATES, FeatureKey } from '@/lib/featureGates';
import { useDialog } from '@/providers/DialogProvider';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface UpgradeDialogProps {
  feature: FeatureKey;
}

export const UpgradeDialog = ({ feature }: UpgradeDialogProps) => {
  const { t } = useTranslation('featureGate');
  const { dismissActiveDialog } = useDialog();
  const { hasRole } = useOrganizations();
  const navigate = useNavigate();

  const tier = FEATURE_GATES[feature].minTier;
  const tierName = TIER_DISPLAY_NAMES[tier];
  const featureName = t(`feature.${feature}`);
  const canUpgrade = hasRole('ADMIN');

  const handleViewPlans = () => {
    dismissActiveDialog();
    navigate('/subscription');
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle>{t('dialog.title', { feature: featureName })}</DialogTitle>
        <DialogDescription>
          {canUpgrade
            ? t('dialog.body', { feature: featureName, tier: tierName })
            : t('dialog.askAdmin', { feature: featureName, tier: tierName })}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant='outline' onClick={dismissActiveDialog}>
          {t('dialog.cancel')}
        </Button>
        {canUpgrade && <Button onClick={handleViewPlans}>{t('dialog.cta')}</Button>}
      </DialogFooter>
    </>
  );
};
